import { render, staticRenderFns } from "./TaskWarning.vue?vue&type=template&id=0c6c11e6&"
import script from "./TaskWarning.vue?vue&type=script&lang=ts&"
export * from "./TaskWarning.vue?vue&type=script&lang=ts&"
import style0 from "./TaskWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
